import { Outlet, Navigate } from "react-router-dom";
import { AppSidebar, MobileHeader } from "./AppSidebar";
import { useAuth } from "@/hooks/useAuth";
import { useOrg } from "@/hooks/useOrg";

export function AppLayout() {
  const { user, loading: authLoading } = useAuth();
  const { org, orgs, loading: orgLoading } = useOrg();

  if (authLoading || orgLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (orgs.length === 0) return <Navigate to="/onboarding" replace />;

  return (
    <div className="flex h-screen flex-col md:flex-row bg-background">
      <AppSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <MobileHeader />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
